/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import * as uxstackpb from '@uxstack/sdk-proto-js/uxstack/sdk/v1/sdk_pb';
import { DOM } from '../../dom';
import { Logger } from '../../logger';
import { EventPayload } from './payload';

export class PageClickPayload extends uxstackpb.PageClickPayload implements EventPayload {
  constructor(event: MouseEvent) {
    const selector = DOM.getSelector(event.currentTarget);

    Logger.debug('Intercept click on', event.currentTarget, ' (', selector, ')');

    super({
      selector,
      text: (event.currentTarget as HTMLElement).innerText,
    });

    const scroll = this._getScrollCoordinate();

    this.coordinates = new uxstackpb.Coordinates({
      client: {
        x: event.clientX,
        y: event.clientY,
      },
      offset: {
        x: event.offsetX,
        y: event.offsetY,
      },
      page: {
        x: event.pageX,
        y: event.pageY,
      },
      scroll: {
        x: scroll.x,
        y: scroll.y,
      },
    });
  }

  public toPayload(): typeof uxstackpb.EventMessage.prototype.payload {
    return {
      case: 'pageClick',
      value: this,
    };
  }

  private _getScrollCoordinate(): { x: number; y: number } {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

    const x = supportPageOffset
      ? window.pageXOffset
      : isCSS1Compat
        ? document.documentElement.scrollLeft
        : document.body.scrollLeft;
    const y = supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;

    return {
      x,
      y,
    };
  }
}
